import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 15000,
    headers: { "Content-Type": "application/json" },
});

export const submitLead = async (type, payload) => {
    const path = {
        consultation: "/leads/consultation",
        siteHost: "/leads/site-host",
        grant: "/leads/grant",
        contact: "/leads/contact",
    }[type];
    if (!path) throw new Error(`Unknown lead type: ${type}`);
    const { data } = await api.post(path, payload);
    return data;
};

export const fetchImpactMetrics = async () => {
    const { data } = await api.get("/metrics/impact");
    return data;
};
